import React from 'react';

import {ForecastQueryRenderer} from '../../../../../../../ForecastQueryRenderer';
import {RelayProps} from '../../../../../../../relay-helpers/TSRelayConverter';

import BulkInvoiceCreateModal, {BulkInvoiceCreateModalQuery} from './BulkInvoiceCreateModal';
import type {BulkInvoiceCreateModal_viewer$data as BulkInvoiceCreateModal_viewer} from './__generated__/BulkInvoiceCreateModal_viewer.graphql';

type BulkInvoiceCreateModalQueryWrapperProps = {
	projectId: string;
	projectPeriodIds: string[];
	closeModal: () => void;
	onStay: () => void;
};

function BulkInvoiceCreateModalQueryWrapper({
	projectId,
	projectPeriodIds,
	closeModal,
	onStay,
}: BulkInvoiceCreateModalQueryWrapperProps): JSX.Element {
	return (
		<ForecastQueryRenderer
			key="query-render-bulk_invoice_create_modal"
			query={BulkInvoiceCreateModalQuery}
			modal={true}
			variables={{projectId}}
			render={(relayProps: RelayProps<BulkInvoiceCreateModal_viewer>) => {
				return (
					<BulkInvoiceCreateModal
						{...relayProps}
						onStay={onStay}
						projectPeriodIds={projectPeriodIds}
						closeModal={closeModal}
					/>
				);
			}}
		/>
	);
}

export default BulkInvoiceCreateModalQueryWrapper;
